export default __webpack_public_path__ + "static/media/cloud.ed99fff7.webp";